// extracted by mini-css-extract-plugin
module.exports = {"basketSmall":"P-uRWnC","basketHeader":"_3hcvLzN","basketStats":"KteKRqI","needMore":"_224ghvr","basketButtonContainer":"_2L8UM36"};